var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-py-2 md:tw-py-5 c-blue-text"},[_c('router-link',{staticClass:"tw-flex tw-items-center",attrs:{"to":_vm.to}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-arrow-left")]),_vm._t("default",function(){return [_vm._v("Back")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }